<template>
  <div
    v-if="loading"
    class="flex justify-center my-4"
  >
    <CarvisSpinner class="w-24 h-24" />
  </div>
  <div
    v-else-if="items?.length === 0"
    aria-label="table-body"
    class="text-gray-500 text-base lg:text-xl w-full py-8 text-center"
  >
    <slot name="no-data" />
  </div>
  <div
    v-else
    aria-label="table-body"
    class="divide-y-2 divide-gray-200"
  >
    <div
      v-for="item in items"
      :key="item.id"
      aria-label="table-row"
      class="p-2 flex justify-between items-center gap-x-4 transition-colors duration-150 hover:bg-gray-50"
    >
      <slot :item="item" />
    </div>
  </div>
</template>

<script lang="ts" setup generic="T extends { id: string }">

defineProps<{
  loading: boolean
  items: T[] | null
}>()
</script>
